import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = [
  'claude-sonnet-4-5',
  'claude-sonnet-4-5-20250929',
  'claude-opus-4-20250514',
  'claude-sonnet-4-20250514',
  'claude-3-7-sonnet-latest',
  'claude-3-5-haiku-latest',
  'claude-3-5-sonnet-latest',
  'claude-3-7-sonnet-20250219',
  'claude-3-5-haiku-20241022',
  'claude-3-5-sonnet-20241022',
  'claude-3-5-sonnet-20240620',
  'claude-3-opus-latest',
  'claude-3-opus-20240229',
  'claude-3-sonnet-20240229',
  'claude-3-haiku-20240307',
].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'claude-sonnet-4-5';

export function useChatAnthropicModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferChatAnthropicManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun>,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    params?.ls_provider !== 'anthropic' ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  const clientOptions = serializedModel?.kwargs?.client_options;

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'anthropic', 'ChatAnthropic'],
    kwargs: {
      ...(params.ls_model_name !== undefined && {
        model: params.ls_model_name,
      }),
      ...(params.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      ...(clientOptions !== undefined && {
        ...(clientOptions?.base_url && { base_url: clientOptions?.base_url }),
        ...(clientOptions?.timeout && { timeout: clientOptions?.timeout }),
        ...(clientOptions?.max_retries && {
          max_retries: clientOptions?.max_retries,
        }),
        ...(clientOptions?.default_headers && {
          default_headers: clientOptions?.default_headers,
        }),
      }),
      client_options: undefined,
    },
  };
}
